module.exports = __webpack_public_path__ + "media/src/images/icon/fa-arrow-right-white-008c7c97c536a927b184bcdef5c1f301.gif";